import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import clientSDK from '../../../../ClientSDK'
import {
  axiosErrorHandler,
  IThunkReject,
} from '../../../../Util/axiosErrorHandler'
import { IWorkingHours, IAPIWorkingHours } from '../interface/IWorkingHours'
import { workingHoursTransformer } from '../transformer/workingHoursTransformer'

export const fetchWorkingHours = createAsyncThunk<
  IWorkingHours[],
  undefined,
  IThunkReject<any>
>('workingHours/fetch', async (_, { rejectWithValue }) => {
  let apiData: IWorkingHours[] = []

  // TODO refactor workinghours endpoint since /api/working-hours has been removed
  // this and all other store/feature files will be removed when removing CalendarNew Component
  try {
    const promise = clientSDK
      .instance()
      .get<{ data: IAPIWorkingHours[] }>(`working-hours`)

    const result = await promise
    apiData = workingHoursTransformer(result.data.data)
  } catch (error) {
    const handleAxiosError = axiosErrorHandler<any>(res => res)
    const generatedError = handleAxiosError(error as Error | AxiosError)
    return rejectWithValue(generatedError)
  }
  console.log('CHECK', apiData)
  return apiData
})
